import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { authGrpList } from 'lib/api/auth';
import { getScriptUserInfo, getScriptUserModify } from 'lib/api/script';
import { paramConverter, Validator } from 'modules/common';

import NewInput from 'components/atoms/NewInput';
import MbTooltip from 'components/atoms/MbTooltip';
import NewButton from 'components/molecules/NewButton';
import FunctionWrap from 'components/molecules/FunctionWrap';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewAutoComplete from 'components/molecules/NewSelectBox/NewAutoComplete';
import Modal from 'components/organisms/NewModal';

const Dashboard = (props) => {
  const { t } = useTranslation();
  const { handleClickSnackbar, handleLoading } = props;

  let initParams = {
    order: 'SCRIPT_USER_NAME',
    sort: 'asc',
  };
  const [params, setParams] = useState(initParams);
  const [groupList, setGroupList] = useState([]);
  const initModal = {
    open: false,
    initParams: {},
    params: {},
    headerTitle: t('트렐로 KEY 수정'),
    confirmBtnTitle: t('수정'),
  };
  const [modal, setModal] = useState(initModal);
  const initError = { trelloId: false };
  const [error, setError] = useState(initError);
  const [reFetch, setReFetch] = useState(false);

  useEffect(() => {
    authGrpList()
      .then((response) => {
        const { data } = response.data;
        setGroupList(data);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: { type: 'error' },
        });
      });
    // eslint-disable-next-line
  }, []);

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const getModalParam = (newParams) => {
    if (JSON.stringify(modal.params) !== JSON.stringify(newParams)) {
      setModal({ ...modal, params: newParams });
    }
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return (
          <TableBtnWrap>
            <MbTooltip title={t('수정')}>
              <NewButton
                iconBtn
                name="edit"
                icon="faEdit"
                onClick={(e) => handleModalOpen(e, data)}
              />
            </MbTooltip>
          </TableBtnWrap>
        );
      },
    });
    return result;
  })();

  const handleModalClose = () => {
    setModal(initModal);
  };

  const handleSubmit = () => {
    let validator = false;
    validator = Validator(paramConverter(modal['params']), error);
    if (!!validator['state']) {
      setError(validator['validate']);
      handleClickSnackbar({
        message: t('필수값을 입력해주세요.'),
        option: { type: 'error' },
      });
    } else {
      getScriptUserModify(modal['params'])
        .then((response) => {
          handleClickSnackbar({
            message: t('수정되었습니다.'),
            option: { type: 'success' },
          });
          handleModalClose();
          setReFetch(true);
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: { type: 'error' },
          });
        })
        .finally((f) => {
          setReFetch(false);
        });
    }
  };

  const handleModalOpen = (e, data) => {
    setModal({
      ...initModal,
      open: true,
      params: { userId: data['SCRIPT_USER_ID'] },
    });
  };

  return (
    <>
      <FunctionWrap loading={false}>
        <NewAutoComplete
          list={groupList}
          label={t('그룹명')}
          name="grpNo"
          valueKey="GRP_NO"
          labelKey="GRP_NAME"
          getParam={getParam}
          params={params}
          style={{ width: 250 }}
          loading={false}
        />
      </FunctionWrap>
      <NewTableContainer
        dataReqPromise={getScriptUserInfo}
        getParam={(f) => f}
        params={params}
        reFetch={reFetch}
        addColumnList={addColumnList}
        useFetch={false}
        useTotal={false}
        useToolBar={false}
        usePagenation={false}
        rowsPerPage={-1}
        callBack={() => handleLoading(false)}
      />
      <Modal
        open={modal.open}
        headerTitle={modal.headerTitle}
        handleClose={handleModalClose}
        confirmBtnTitle={modal.confirmBtnTitle}
        useStyle={{ width: '800px' }}
        confirmOnClick={handleSubmit}
      >
        <NewInput
          type="tableInput"
          name="trelloId"
          params={modal.params}
          value={modal.params['trelloId']}
          callBack={getModalParam}
          error={error['trelloId']}
        />
      </Modal>
    </>
  );
};

export default withRouter(Dashboard);
